<div class="_calendar-recurring-change-component">
    <p class="_calendar-recurring-change-question" [innerHTML]="(action === Action.DELETE ? 'EVENT.RECURRING_DELETE_CONFIRMATION' : 'EVENT.RECURRING_UPDATE_CONFIRMATION') | translate"></p>
    <div class="_buttons-container">
        <button type="button" (click)="cancel()" class="_button _cancel-button" [translate]="'BUTTONS.CANCEL'"></button>
        <button type="button" (click)="answer(false)" class="_button _delete-button" [translate]="(action === Action.DELETE ? 'EVENT.DELETE_ONE' : 'EVENT.UPDATE_ONE')"></button>
        <button type="button" (click)="answer(true)" class="_button _delete-button" [translate]="(action === Action.DELETE ? 'EVENT.DELETE_RECURRING' : 'EVENT.UPDATE_RECURRING')"></button>
    </div>
</div>
